function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "manage jobs icon",
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2023",
  d: "M10.377 3.624A3.624 3.624 0 116.749 0a3.624 3.624 0 013.624 3.624z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2024",
  d: "M3.566 12.293a1.49 1.49 0 012.581-.958L8.2 13.544l3.64-4.061a8.946 8.946 0 00-5.082-1.5 8.584 8.584 0 00-6.652 2.9.532.532 0 00-.106.325v2.868a1.064 1.064 0 001.032 1.064h4.561l-1.634-1.756a1.5 1.5 0 01-.394-1.091z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2025",
  d: "M12.485 15.14a1.064 1.064 0 001.032-1.064v-2l-2.73 3.065z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2026",
  d: "M15.151 8.021a.532.532 0 00-.756.043l-6.183 6.917-2.767-2.975a.513.513 0 10-.75.7l3.555 3.832 6.94-7.781a.532.532 0 00-.039-.736z"
}));
var SvgManageJobs = function SvgManageJobs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.318,
    height: 16.535
  }, props), _ref);
};
export default SvgManageJobs;